const waitFor = (time) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => { resolve() }, time)
  })
}

export { waitFor }